<app-edit-profile (callback)="updatedUser($event)"></app-edit-profile>
<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col-12 h-100 d-flex p-0 overflow-hidden">
      <app-side-nav-bar></app-side-nav-bar>
      <div class="panel w-100">
        <div class="top-bar">
          <div class="d-flex justify-content-between w-100 d-lg-none" (click)="menu_open = true">
            <img src="assets/images/menu-mobile.svg" alt="menu-bars-icon">
            <div class="icon bell"></div>
          </div>

          <breadcrumb #parent>  
            <div class="wac-breadcrum d-none d-lg-flex">
              <div class="item">Atalaya</div>
 
              <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
                <div *ngIf="!route.terminal" class="item">
                  <a href="" [routerLink]="[route.url]">{{ route.displayName }}</a>
                </div>
                <div *ngIf="route.terminal" class="item active" aria-current="page">{{ route.displayName }}</div>
              </ng-template>
            </div>
          </breadcrumb>
          
          <div class="action-bar" [ngClass]="{opened: menu_open}">

            <!-- Search -->
            <!-- <div class="icon-wrapper search">
              <onwac-button 
              [text]="'HOME.search' | translate" 
              [type]="'icon'" 
              [icon]="'search'"
              [extra_clases]="'white'"></onwac-button>
              <span>{{'HOME.search' | translate}}</span>
            </div> -->

            <!-- Meetings -->
            <!-- <div class="icon-wrapper position-relative">
              <onwac-button 
              [text]="'meetings'" 
              [type]="'icon'" 
              [icon]="'calendar_today'"
              [extra_clases]="meetingsManagement.show ? 'white active': 'white'"
              (click)="meetingsManagement.toggle()"></onwac-button>
              <div *ngIf="meetingsManagement.new" (click)="meetingsManagement.toggle()" class="dot-alert red"></div>
              <app-meetings-management></app-meetings-management>
            </div> -->

            <!-- Notifications -->
            <div class="icon-wrapper bell-notifications">
              <onwac-button 
              [text]="'notifications'" 
              [type]="'icon'" 
              [icon]="'notifications'"
              [extra_clases]="notifications.show ? 'white active': 'white'"
              (click)="notifications.toggleNotifications()"></onwac-button>
              <div *ngIf="notifications.new" (click)="notifications.toggleNotifications()" class="dot-alert red"></div>
              <app-notifications></app-notifications>
            </div>

            <!-- Profile -->
            <div class="avatar-dropdown ">
              <div class="avatar d-flex cursor" (click)="editProfile.open()" *ngIf="userAvatar" [style.background-image]="'url(' + userAvatar + ')'" [title]="'HOME.editProfile' | translate"></div>
              <!-- Todo: sacar desplegable?-->
            </div>

            <!-- Logout -->
            <div class="icon-wrapper logout" (click)="logout()">
              <onwac-button 
              [text]="'HOME.closeSession' | translate" 
              [type]="'icon'" 
              [icon]="'exit_to_app'"
              [extra_clases]="'white'"></onwac-button>
              <span>{{'HOME.closeSession' | translate}}</span>
            </div>

            <div class="toggler-menu-hiden" (click)="menu_open = false"></div>
          </div>
        </div>
        <div class="col-12 page-container">
          <router-outlet #route="outlet"></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>


<onwac-snackbar 
[status_class]="snackbar.status_class"
[text]="snackbar.text"
[autoClose]="snackbar.autoClose"
[time]="snackbar.time"
[action_buttons]="snackbar.action_buttons"
[activate]="snackbar.active"
(hidden)="snackbar.deactivate()"
></onwac-snackbar>
